<button
  mat-stroked-button
  color="buttonSuccess"
  class="create-data-convention-button"
  (click)="openDialog()"
>
  Create data convention
</button>
